import { EmailChange } from '../../components/email/email.js';

/**
 * Account
 */
export const Account = (function () {

  var init =  function () {   
      
      // Init the email change as the component is used in the Account pattern
      EmailChange.init();
       
  }

  return {
    init: init
  }

}());


